import _asyncToGenerator from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/regenerator/index.js";
import { setContext, captureException } from '@sentry/core';
import { RETRY_MAX_COUNT, UNABLE_TO_SEND_REPLAY, RETRY_BASE_INTERVAL } from '../constants.js';
import { sendReplayRequest, RateLimitError, TransportStatusCodeError } from './sendReplayRequest.js';

/**
 * Finalize and send the current replay event to Sentry
 */
function sendReplay(_x) {
  return _sendReplay.apply(this, arguments);
}
function _sendReplay() {
  _sendReplay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(replayData) {
    var retryConfig,
      recordingData,
      options,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            retryConfig = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {
              count: 0,
              interval: RETRY_BASE_INTERVAL
            };
            recordingData = replayData.recordingData, options = replayData.options; // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
            if (recordingData.length) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return");
          case 4:
            _context2.prev = 4;
            _context2.next = 7;
            return sendReplayRequest(replayData);
          case 7:
            return _context2.abrupt("return", true);
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](4);
            if (!(_context2.t0 instanceof RateLimitError || _context2.t0 instanceof TransportStatusCodeError)) {
              _context2.next = 14;
              break;
            }
            throw _context2.t0;
          case 14:
            // Capture error for every failed replay
            setContext('Replays', {
              _retryCount: retryConfig.count
            });
            if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && options._experiments && options._experiments.captureExceptions) {
              captureException(_context2.t0);
            }

            // If an error happened here, it's likely that uploading the attachment
            // failed, we'll can retry with the same events payload
            if (!(retryConfig.count >= RETRY_MAX_COUNT)) {
              _context2.next = 18;
              break;
            }
            throw new Error("".concat(UNABLE_TO_SEND_REPLAY, " - max retries exceeded"));
          case 18:
            // will retry in intervals of 5, 10, 30
            retryConfig.interval *= ++retryConfig.count;
            _context2.next = 21;
            return new Promise(function (resolve, reject) {
              setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return sendReplay(replayData, retryConfig);
                      case 3:
                        resolve(true);
                        _context.next = 9;
                        break;
                      case 6:
                        _context.prev = 6;
                        _context.t0 = _context["catch"](0);
                        reject(_context.t0);
                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 6]]);
              })), retryConfig.interval);
            });
          case 21:
            return _context2.abrupt("return", _context2.sent);
          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 10]]);
  }));
  return _sendReplay.apply(this, arguments);
}
export { sendReplay };